import { Clock, Mail, Phone, LogOut, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

export const AwaitingApproval = () => {
  const { signOut, refreshProfile } = useAuth();

  const handleRefresh = async () => {
    await refreshProfile();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/30 p-4">
      <div className="max-w-lg w-full text-center space-y-6">
        {/* Ícone Animado */}
        <div className="mx-auto w-24 h-24 rounded-full bg-amber-500/10 flex items-center justify-center">
          <Clock className="h-12 w-12 text-amber-500 animate-pulse" />
        </div>

        {/* Título */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Aguardando Aprovação</h1>
          <p className="text-xl text-muted-foreground">
            Sua empresa está em processo de verificação.
          </p>
        </div>

        {/* Informações */}
        <div className="bg-amber-500/5 border border-amber-500/20 rounded-lg p-4">
          <p className="text-sm text-muted-foreground">
            Nosso time está analisando os dados do seu cadastro. 
            Este processo geralmente leva até <strong className="text-foreground">24 horas úteis</strong>.
          </p>
        </div>

        {/* Instruções de Contato */}
        <div className="bg-muted/50 rounded-lg p-6 text-left space-y-4">
          <p className="text-sm text-muted-foreground">
            Se você precisar de uma aprovação mais rápida ou tiver dúvidas, 
            entre em contato com nosso suporte:
          </p>
          
          <div className="space-y-3">
            <a 
              href="mailto:suporte@gonx.com.br"
              className="flex items-center gap-3 text-primary hover:underline"
            >
              <Mail className="h-5 w-5" />
              <span>suporte@gonx.com.br</span>
            </a>
            
            <a 
              href="https://wa.me/5511999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-primary hover:underline"
            >
              <Phone className="h-5 w-5" />
              <span>WhatsApp: (11) 99999-9999</span>
            </a>
          </div>
        </div>

        {/* Botões de Ação */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={handleRefresh}
            className="gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            Verificar Status
          </Button>
          
          <Button
            variant="ghost"
            onClick={signOut}
            className="gap-2 text-muted-foreground hover:text-foreground"
          >
            <LogOut className="h-4 w-4" />
            Sair da Conta
          </Button>
        </div>

        {/* Rodapé */}
        <p className="text-xs text-muted-foreground">
          GOnX - Sistema de Gestão Empresarial
        </p>
      </div>
    </div>
  );
};
